module.exports = __webpack_public_path__ + "img/tb1039-1974.asm.ea3a0b3e.jpg";